import { ChangeDetectionStrategy, Component, inject, input, output, signal } from '@angular/core';
import { chatHistory } from '../../../digital-assistant.model';
import { DigitalAssistantService } from '../../../digital-assistant.service';
import { MatIcon } from '@angular/material/icon';
import { DatePipe } from '@angular/common';
import { L10nTranslatePipe } from 'angular-l10n';


@Component({
  selector: 'miq-chat-left-panel',
  template: `
    <!-- Left Panel -->

    <div class="left-panel">
      <div class="panel-content">
        <div class="panel-header">
          <div class="header-title">
            <mat-icon (click)="toggleLeftPanel()">arrow_back</mat-icon>
            <span class="chats-label">{{ 'chat.chats' | translate }}</span>
          </div>
          <div>({{ chatHistory().length }})</div>
        </div>
        <hr />
        <div class="panel-body">
          <div class="new-chat">
            <button mat-button class="new-chat-button" (click)="newSession()">
              <mat-icon svgIcon="new-chat-v1"></mat-icon>
              <span>{{ 'chat.newChat' | translate }}</span>
            </button>
          </div>
          <p class="chat-history-note">{{ 'chat.historyNote' | translate }}</p>
          <div class="chat-history">
            @if (chatHistory().length > 0) {
              @for (chat of chatHistory(); track chat) {
                <!--to show latest on top-->
                <div class="chat-item-container" (click)="selectChat(chat)">
                  <div class="chat-item-title">
                    {{ chat.messages[0].content }}
                  </div>
                  <div class="chat-item-date">
                    {{ chat.messages[0].timestamp | date: 'MM/dd' }}
                  </div>
                </div>
              }
            }
          </div>
        </div>
      </div>
    </div>
    `,
  styleUrl: './chat-left-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, DatePipe, L10nTranslatePipe],
})
export class ChatLeftPanelComponent {
  readonly emitNewSession = output<void>();
  readonly emitSelectedSession = output<chatHistory>();
  readonly chatHistory = input<chatHistory[]>([]);

  public chatBotService = inject(DigitalAssistantService);

  constructor() {
    this.chatBotService.isLeftPanelOpen = signal(false);
  }

  toggleLeftPanel() {
    this.chatBotService.isLeftPanelOpen.update(value => !value);
    this.chatBotService.trackUserAction('Chat history panel toggled');
  }

  newSession(): void {
    this.chatBotService.isLeftPanelOpen.update(value => !value);
    this.emitNewSession.emit();
  }

  selectChat(chat: chatHistory): void {
    this.chatBotService.isLeftPanelOpen.update(value => !value);
    this.emitSelectedSession.emit(chat);
    const actionDetailParams = {
      selectedHistory: {
        sessionId: chat.sessionId,
        historyTitle: chat.messages[0].content,
      },
    };
    this.chatBotService.trackUserAction('Chat selected from history', actionDetailParams);
  }
}
